/**
 * Check if argument is a promise
 * @param {*} value
 * @returns true if argument is a promise
 */
const isPromise = value => typeof value === 'object' && typeof value.then === 'function';

export default isPromise;
